import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import SvgIcon from '@/components/SvgIcon.vue';
import { copy } from '@/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'IconCopy',
  props: {
    copyValue: null,
    copyIconName: {
      default: ''
    },
    copyIconGreyName: {
      default: ''
    },
    placement: {
      default: 'topLeft'
    },
    styleValue: {
      default: ''
    },
    fontSize: {
      default: '22px'
    }
  },
  setup(__props) {
    const props = __props;
    const handleCopy = value => {
      copy(value);
    };
    return (_ctx, _cache) => {
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      return _openBlock(), _createBlock(_component_a_tooltip, {
        placement: props.placement,
        "auto-adjust-overflow": false,
        overlayStyle: {
          maxWidth: '800px'
        },
        getPopupContainer: triggerNode => {
          return triggerNode.parentNode;
        }
      }, _createSlots({
        default: _withCtx(() => [_createVNode(SvgIcon, {
          iconClass: props.copyValue ? props.copyIconName : props.copyIconGreyName,
          class: _normalizeClass(["copyIcon", props.copyValue ? 'active' : 'gray']),
          style: _normalizeStyle(props.styleValue ? props.styleValue : `margin: 0 10px 0 0; fontSize: ${props.fontSize}`),
          onClick: _cache[0] || (_cache[0] = $event => handleCopy(String(props.copyValue) || ''))
        }, null, 8, ["iconClass", "class", "style"])]),
        _: 2
      }, [props.copyValue ? {
        name: "title",
        fn: _withCtx(() => [_createTextVNode(_toDisplayString(props.copyValue), 1)]),
        key: "0"
      } : undefined]), 1032, ["placement", "getPopupContainer"]);
    };
  }
});